import React, { useState, useEffect, useRef } from 'react';
import grey from '../assets/Thandiwe.jpg';

const BusinessSection = () => {
  const [slide, setSlide] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setSlide(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div
      ref={sectionRef}
      className="p-8 flex flex-col md:flex-row justify-between items-center "
    >
      <div
        className={`w-full md:w-1/2 pr-8 mb-8 lg:w-1/2 mt-8 lg:mt-0 order-2 lg:order-1 ${
          slide ? 'animate-slide-in' : ''
        }`}
      >
         <h1 className="text-md font-bold text-blue-800">Who We Are</h1>
        <p className="mt-4 text-justify text-gray-600">
          We're an
            Information Technology Integration and Management
          agency. We deliver bespoke technology Integration solutions through
          research, business-case and process analysis, deployment of IT
          infrastructure, and integration of data analytics. Our services cut
          across industries, helping clients use technology to optimize business
          productivity.
        </p>
        <p className="mt-4 text-justify text-gray-600">
            Our Commitment to Customers
          is what makes us unique. It was out of recognition of the ever
          increasingly connected world that Integrated Business Solutions was
          birthed. The rise of modern channels of communication and connectivity
          such as mobile, social media and the Internet-of-Things has invoked
          new and improved ways of managing business value-chains.
        </p>
      </div>
      <div
        className={`w-full md:w-1/2 px-0 shadow-xl rounded-lg flex-1 ml-0 lg:ml-5 text-justify order-1 lg:order-2 ${
          slide ? 'animate-slide-in' : ''
        }`}
      >
        <div className="img_container">
          <div className="img-box overflow-hidden rounded-sm">
            <img
              src={grey}
              alt=""
              className={slide ? 'zoom-in-out' : ''}
              style={{
                width: '100%',
                height: 'auto',
                transition: 'transform 0.5s',
              }}
            />
          </div>
        </div>
      </div>

      <style>{`
        @keyframes slideIn {
          from {
            transform: translateY(20px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        
        @keyframes zoomInOut {
          0% {
            transform: scale(1);
          }
          100% {
            transform: scale(1.05);
          }
        }

        .animate-slide-in {
          animation: slideIn 0.5s ease-out forwards;
        }

        .zoom-in-out {
          animation: zoomInOut 3s infinite alternate;
        }
      `}</style>
    </div>
  );
};

export default BusinessSection;
